import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "list-page-table-panel list-page-table-panel--fill"
};
const _hoisted_2 = {
  class: "data-table-shell"
};
const _hoisted_3 = {
  class: "data-table-scroll data-table-scroll--fill"
};
const _hoisted_4 = {
  class: "data-table text-sm min-w-[960px]"
};
const _hoisted_5 = {
  key: 1
};
const _hoisted_6 = {
  class: "data-table-td"
};
const _hoisted_7 = {
  class: "flex items-center gap-2"
};
const _hoisted_8 = {
  class: "text-sm font-medium text-slate-900"
};
const _hoisted_9 = {
  class: "data-table-td"
};
const _hoisted_10 = {
  class: "px-2 py-1 bg-slate-100 text-slate-700 rounded text-xs"
};
const _hoisted_11 = {
  class: "data-table-td"
};
const _hoisted_12 = {
  class: "text-sm text-slate-600"
};
const _hoisted_13 = {
  class: "data-table-td"
};
const _hoisted_14 = {
  class: "text-sm text-slate-600"
};
const _hoisted_15 = {
  class: "data-table-td"
};
const _hoisted_16 = {
  class: "flex items-center gap-1"
};
const _hoisted_17 = {
  class: "text-sm text-slate-900"
};
const _hoisted_18 = {
  class: "flex flex-col"
};
const _hoisted_19 = ["onClick"];
const _hoisted_20 = ["onClick"];
const _hoisted_21 = {
  class: "data-table-td"
};
const _hoisted_22 = {
  class: "data-table-td text-slate-600"
};
const _hoisted_23 = {
  class: "data-table-td is-center data-table-sticky-right data-table-sticky-action"
};
const _hoisted_24 = {
  class: "flex items-center justify-center gap-1"
};
const _hoisted_25 = ["onClick"];
const _hoisted_26 = ["onClick"];
const _hoisted_27 = {
  class: "p-6 text-center"
};
const _hoisted_28 = {
  class: "text-sm text-slate-500 mb-6"
};
import { ref, reactive, onMounted } from 'vue';
import { ElMessage } from 'element-plus';
import AppPagination from '@/components/AppPagination.vue';
import ListPageShell from '@/components/ListPageShell.vue';
import PageFilterBar from '@/components/PageFilterBar.vue';
import AppModal from '@/components/AppModal.vue';
import { getCommissionRulePage, deleteCommissionRule, updateCommissionRulePriority } from '@/api/commission';
import CommissionRuleForm from './CommissionRuleForm.vue';

// 分账规则表单弹窗状态

export default {
  __name: 'CommissionRuleList',
  setup(__props) {
    const ruleFormVisible = ref(false);
    const ruleFormEditId = ref(null);

    // 规则类型
    const ruleTypes = [{
      value: 'GLOBAL',
      label: '全局规则'
    }, {
      value: 'FRANCHISEE',
      label: '加盟商规则'
    }, {
      value: 'PRODUCT',
      label: '产品规则'
    }];
    const searchForm = reactive({
      ruleType: '',
      status: ''
    });
    const loading = ref(false);
    const ruleList = ref([]);
    const pagination = reactive({
      current: 1,
      size: 20,
      total: 0,
      pages: 0
    });
    const showDeleteModal = ref(false);
    const deleteTarget = ref(null);
    const getTypeLabel = type => {
      const found = ruleTypes.find(t => t.value === type);
      return found ? found.label : type;
    };
    const fetchRules = async () => {
      loading.value = true;
      try {
        const params = {
          ruleType: searchForm.ruleType || undefined,
          status: searchForm.status !== '' ? Number(searchForm.status) : undefined,
          pageNum: pagination.current,
          pageSize: pagination.size
        };
        const res = await getCommissionRulePage(params);
        const data = res.data || res;
        ruleList.value = data.records || [];
        pagination.current = data.current;
        pagination.size = data.size;
        pagination.total = data.total;
        pagination.pages = data.pages;
      } catch (error) {
        ElMessage.error(error.message || '获取规则列表失败');
      } finally {
        loading.value = false;
      }
    };
    const handleSearch = () => {
      pagination.current = 1;
      fetchRules();
    };
    const resetSearch = () => {
      searchForm.ruleType = '';
      searchForm.status = '';
      pagination.current = 1;
      fetchRules();
    };
    const handlePageChange = page => {
      if (page < 1 || page > pagination.pages) return;
      pagination.current = page;
      fetchRules();
    };
    const handlePageSizeChange = size => {
      pagination.size = size;
      pagination.current = 1;
      fetchRules();
    };
    const goToCreate = () => {
      ruleFormEditId.value = null;
      ruleFormVisible.value = true;
    };
    const goToEdit = rule => {
      ruleFormEditId.value = rule.id;
      ruleFormVisible.value = true;
    };
    const deleteRule = rule => {
      deleteTarget.value = rule;
      showDeleteModal.value = true;
    };
    const closeDeleteModal = () => {
      showDeleteModal.value = false;
      deleteTarget.value = null;
    };
    const confirmDelete = async () => {
      if (!deleteTarget.value) return;
      try {
        await deleteCommissionRule(deleteTarget.value.id);
        ElMessage.success('删除成功');
        fetchRules();
      } catch (error) {
        ElMessage.error(error.message || '删除失败');
      } finally {
        closeDeleteModal();
      }
    };
    const changePriority = async (rule, delta) => {
      try {
        await updateCommissionRulePriority(rule.id, rule.priority + delta);
        fetchRules();
      } catch (error) {
        ElMessage.error(error.message || '更新优先级失败');
      }
    };
    onMounted(() => {
      fetchRules();
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      return _openBlock(), _createBlock(ListPageShell, {
        fill: ""
      }, {
        header: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createElementVNode("div", {
          class: "list-page-panel is-header-minimal"
        }, [_createElementVNode("div", {
          class: "list-page-heading"
        }, [_createElementVNode("div", {
          class: "list-page-heading-main"
        }, [_createElementVNode("h1", {
          class: "list-page-title"
        }, "分账规则管理"), _createElementVNode("p", {
          class: "list-page-description"
        }, "配置和管理分账规则")])])], -1)]))]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(PageFilterBar, {
          "shell-class": "filter-bar-shell is-embedded",
          "body-class": "filter-bar-body is-panel",
          "show-refresh": true,
          "refresh-loading": loading.value,
          onRefresh: fetchRules
        }, {
          searchActionsLeading: _withCtx(() => [_createElementVNode("button", {
            type: "button",
            class: "btn-primary",
            onClick: goToCreate
          }, [...(_cache[4] || (_cache[4] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 4v16m8-8H4"
          })], -1), _createTextVNode(" 新增规则 ", -1)]))])]),
          searchActions: _withCtx(() => [_createElementVNode("button", {
            type: "button",
            class: "btn-primary",
            onClick: handleSearch
          }, "搜索"), _createElementVNode("button", {
            type: "button",
            class: "btn-secondary",
            onClick: resetSearch
          }, "重置")]),
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: searchForm.ruleType,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => searchForm.ruleType = $event),
            placeholder: "请选择类型",
            class: "form-select form-control-sm filter-bar-field"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "全部类型",
              value: ""
            }), (_openBlock(), _createElementBlock(_Fragment, null, _renderList(ruleTypes, t => {
              return _createVNode(_component_el_option, {
                key: t.value,
                label: t.label,
                value: t.value
              }, null, 8, ["label", "value"]);
            }), 64))]),
            _: 1
          }, 8, ["modelValue"]), _createVNode(_component_el_select, {
            modelValue: searchForm.status,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => searchForm.status = $event),
            placeholder: "请选择状态",
            class: "form-select form-control-sm filter-bar-field"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "全部状态",
              value: ""
            }), _createVNode(_component_el_option, {
              label: "启用",
              value: 1
            }), _createVNode(_component_el_option, {
              label: "停用",
              value: 0
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }, 8, ["refresh-loading"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("table", _hoisted_4, [_cache[12] || (_cache[12] = _createElementVNode("thead", {
          class: "data-table-head"
        }, [_createElementVNode("tr", null, [_createElementVNode("th", {
          class: "data-table-th text-left"
        }, "规则名称"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "规则类型"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "产品"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "加盟商"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "优先级"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "状态"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "创建时间"), _createElementVNode("th", {
          class: "data-table-th text-center data-table-sticky-right data-table-sticky-head data-table-sticky-action"
        }, "操作")])], -1)), _createElementVNode("tbody", null, [loading.value ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, _renderList(5, n => {
          return _createElementVNode("tr", {
            key: n,
            class: "animate-pulse"
          }, [...(_cache[5] || (_cache[5] = [_createElementVNode("td", {
            class: "data-table-td"
          }, [_createElementVNode("div", {
            class: "h-4 w-32 bg-slate-200 rounded"
          })], -1), _createElementVNode("td", {
            class: "data-table-td is-center"
          }, [_createElementVNode("div", {
            class: "h-6 w-20 bg-slate-200 rounded-full"
          })], -1), _createElementVNode("td", {
            class: "data-table-td"
          }, [_createElementVNode("div", {
            class: "h-4 w-20 bg-slate-200 rounded"
          })], -1), _createElementVNode("td", {
            class: "data-table-td"
          }, [_createElementVNode("div", {
            class: "h-4 w-20 bg-slate-200 rounded"
          })], -1), _createElementVNode("td", {
            class: "data-table-td"
          }, [_createElementVNode("div", {
            class: "h-4 w-12 bg-slate-200 rounded"
          })], -1), _createElementVNode("td", {
            class: "data-table-td is-center"
          }, [_createElementVNode("div", {
            class: "h-6 w-16 bg-slate-200 rounded-full"
          })], -1), _createElementVNode("td", {
            class: "data-table-td"
          }, [_createElementVNode("div", {
            class: "h-4 w-24 bg-slate-200 rounded"
          })], -1), _createElementVNode("td", {
            class: "data-table-td is-center data-table-sticky-right data-table-sticky-action"
          }, [_createElementVNode("div", {
            class: "h-8 w-20 bg-slate-200 rounded"
          })], -1)]))]);
        }), 64)) : _createCommentVNode("", true), !loading.value && ruleList.value.length === 0 ? (_openBlock(), _createElementBlock("tr", _hoisted_5, [_createElementVNode("td", {
          colspan: "8",
          class: "data-table-empty"
        }, [_createElementVNode("div", {
          class: "flex flex-col items-center"
        }, [_cache[6] || (_cache[6] = _createElementVNode("svg", {
          class: "w-12 h-12 text-slate-300 mb-3",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
        })], -1)), _cache[7] || (_cache[7] = _createElementVNode("span", null, "暂无分账规则", -1)), _createElementVNode("button", {
          class: "mt-3 text-primary-600 hover:text-primary-700 text-sm",
          onClick: goToCreate
        }, "新建规则")])])])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ruleList.value, rule => {
          return _openBlock(), _createElementBlock("tr", {
            key: rule.id,
            class: "data-table-row"
          }, [_createElementVNode("td", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("span", _hoisted_8, _toDisplayString(rule.ruleName), 1)])]), _createElementVNode("td", _hoisted_9, [_createElementVNode("span", _hoisted_10, _toDisplayString(getTypeLabel(rule.ruleType)), 1)]), _createElementVNode("td", _hoisted_11, [_createElementVNode("span", _hoisted_12, _toDisplayString(rule.productName || '-'), 1)]), _createElementVNode("td", _hoisted_13, [_createElementVNode("span", _hoisted_14, _toDisplayString(rule.franchiseeName || '-'), 1)]), _createElementVNode("td", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createElementVNode("span", _hoisted_17, _toDisplayString(rule.priority), 1), _createElementVNode("div", _hoisted_18, [_createElementVNode("button", {
            class: "p-0.5 text-slate-400 hover:text-primary-600",
            onClick: $event => changePriority(rule, 1)
          }, [...(_cache[8] || (_cache[8] = [_createElementVNode("svg", {
            class: "w-3 h-3",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M5 15l7-7 7 7"
          })], -1)]))], 8, _hoisted_19), _createElementVNode("button", {
            class: "p-0.5 text-slate-400 hover:text-primary-600",
            onClick: $event => changePriority(rule, -1)
          }, [...(_cache[9] || (_cache[9] = [_createElementVNode("svg", {
            class: "w-3 h-3",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M19 9l-7 7-7-7"
          })], -1)]))], 8, _hoisted_20)])])]), _createElementVNode("td", _hoisted_21, [_createElementVNode("span", {
            class: _normalizeClass(["status-badge", rule.status === 1 ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'])
          }, [_createElementVNode("span", {
            class: _normalizeClass(["w-1.5 h-1.5 rounded-full mr-1", rule.status === 1 ? 'bg-green-500' : 'bg-red-500'])
          }, null, 2), _createTextVNode(" " + _toDisplayString(rule.status === 1 ? '启用' : '停用'), 1)], 2)]), _createElementVNode("td", _hoisted_22, _toDisplayString(rule.createTime || '-'), 1), _createElementVNode("td", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_createElementVNode("button", {
            class: "table-action-button is-primary",
            title: "编辑",
            "aria-label": "编辑",
            onClick: $event => goToEdit(rule)
          }, [...(_cache[10] || (_cache[10] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
          })], -1)]))], 8, _hoisted_25), _createElementVNode("button", {
            class: "table-action-button is-danger",
            title: "删除",
            "aria-label": "删除",
            onClick: $event => deleteRule(rule)
          }, [...(_cache[11] || (_cache[11] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
          })], -1)]))], 8, _hoisted_26)])])]);
        }), 128))])])])]), pagination.total > 0 ? (_openBlock(), _createBlock(AppPagination, {
          key: 0,
          class: "pagination-bridge",
          pagination: pagination,
          "page-sizes": [10, 20, 50],
          onPageChange: handlePageChange,
          onSizeChange: handlePageSizeChange
        }, null, 8, ["pagination"])) : _createCommentVNode("", true)]), _createVNode(AppModal, {
          visible: showDeleteModal.value,
          size: "sm",
          "panel-class": "mx-4",
          onClose: closeDeleteModal
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_27, [_cache[13] || (_cache[13] = _createElementVNode("div", {
            class: "w-12 h-12 mx-auto mb-4 text-red-500"
          }, [_createElementVNode("svg", {
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
          })])], -1)), _cache[14] || (_cache[14] = _createElementVNode("h3", {
            class: "text-lg font-semibold text-slate-900 mb-2"
          }, "确定要删除吗？", -1)), _createElementVNode("p", _hoisted_28, "将删除规则 \"" + _toDisplayString(deleteTarget.value?.ruleName) + "\"，删除后无法恢复。", 1), _createElementVNode("div", {
            class: "flex items-center justify-center gap-3"
          }, [_createElementVNode("button", {
            class: "btn-secondary",
            onClick: closeDeleteModal
          }, "取消"), _createElementVNode("button", {
            class: "btn-danger-secondary",
            onClick: confirmDelete
          }, "确定删除")])])]),
          _: 1
        }, 8, ["visible"]), _createVNode(CommissionRuleForm, {
          "model-value": ruleFormVisible.value,
          "edit-id": ruleFormEditId.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ruleFormVisible.value = $event),
          onSuccess: fetchRules
        }, null, 8, ["model-value", "edit-id"])]),
        _: 1
      });
    };
  }
};